var _rect, _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#1a1316"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 36,
    fill: "#e0b0ba",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    letterSpacing: 3
  }, "REWIND")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28,52)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fill: "#c4b0b6",
    fontSize: 12,
    fontFamily: "system-ui,sans-serif"
  }, "2024"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Mar"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Apr"), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "May"), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 191,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jun"), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 246,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jul"), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Aug"), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Sep"), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Oct"), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 433,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Nov"), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 12,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Dec"), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 51,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 62,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 73,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 84,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 18,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 29,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 40,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 157,
    fill: "#c4b0b6",
    fontSize: 12,
    fontFamily: "system-ui,sans-serif"
  }, "2025"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jan"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Feb"), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Mar"), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 191,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Apr"), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(199,154,164)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "May"), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jun"), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 334,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jul"), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Aug"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(173,131,141)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 433,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Sep"), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 477,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Oct"), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(224,176,186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 521,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Nov"), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(173,131,141)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(165,124,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 576,
    y: 129,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Dec"), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 179,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 190,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609,
    y: 201,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 135,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 146,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 157,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 168,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 274,
    fill: "#c4b0b6",
    fontSize: 12,
    fontFamily: "system-ui,sans-serif"
  }, "2026"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jan"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(157,117,127)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Feb"), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Mar"), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 191,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Apr"), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "May"), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(148,109,119)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jun"), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("text", {
    x: 334,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Jul"), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(131,94,104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 246,
    fill: "#8f7a80",
    fontSize: 10,
    fontFamily: "system-ui,sans-serif"
  }, "Aug"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#2c2226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 274,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 285,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 296,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 307,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 318,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 252,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(140,102,112)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 263,
    width: 9,
    height: 9,
    rx: 2,
    fill: "rgb(127,91,101)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.42821370fd91657a738b8e8cece884a8.svg";
export { ForwardRef as ReactComponent };